const transformSnakeToCamelCase = (str: string): string => {
  return str.replace(/_([a-z])/g, (g) => g[1].toUpperCase());
};

const transformCamelToSnakeCase = (str: string): string => {
  return str.replace(/([A-Z])/g, '_$1').toLowerCase();
};

const isObject = (value: unknown): value is Record<string, unknown> => {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
};

const transformObjectCase = (obj: unknown, transformKey: (key: string) => string): unknown => {
  if (Array.isArray(obj)) {
    return obj.map((item) => transformObjectCase(item, transformKey));
  }

  if (isObject(obj)) {
    return Object.keys(obj).reduce(
      (acc, key) => {
        acc[transformKey(key)] = transformObjectCase(obj[key], transformKey);
        return acc;
      },
      {} as Record<string, unknown>
    );
  }

  return obj;
};

export const transformObjectToCamelCase = (obj: unknown): unknown => {
  return transformObjectCase(obj, transformSnakeToCamelCase);
};

export const transformObjectToSnakeCase = (obj: unknown): unknown => {
  return transformObjectCase(obj, transformCamelToSnakeCase);
};
